import type { StatementListRow } from "../features/eex/statements/contracts";

export const STATEMENT_TOTAL_FIELDS = ["spotSettlement", "variationMargin", "fees", "total"] as const;
export type StatementTotalField = (typeof STATEMENT_TOTAL_FIELDS)[number];

export interface StatementFieldTotal {
  /** Sum of the reported values; null when no selected statement reports this field. */
  sum: number | null;
  /** How many selected statements leave this field empty (not counted in the sum). */
  missing: number;
}

export type StatementTotals = Record<StatementTotalField, StatementFieldTotal>;

// Statement amounts are numeric(18,6) strings. Summing them as integer
// micro-euros keeps a multi-month selection exact instead of accumulating
// binary floating-point drift across hundreds of rows.
const SCALE = 1_000_000;

export function sumStatementTotals(
  statements: readonly Pick<StatementListRow, StatementTotalField>[]
): StatementTotals {
  const out = {} as StatementTotals;
  for (const field of STATEMENT_TOTAL_FIELDS) {
    let micros = 0;
    let reported = 0;
    let missing = 0;
    for (const statement of statements) {
      const raw = statement[field];
      const value = raw == null || raw === "" ? NaN : Number(raw);
      if (!Number.isFinite(value)) {
        missing += 1;
        continue;
      }
      micros += Math.round(value * SCALE);
      reported += 1;
    }
    out[field] = { sum: reported > 0 ? micros / SCALE : null, missing };
  }
  return out;
}
